var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { IconButton, Box } from "@mui/material";
import { COLORS } from "../../../../../../constants";
var StyleControlButton = function (_a) {
    var active = _a.active, label = _a.label, testId = _a.testId, isFocused = _a.isFocused, Icon = _a.Icon, last = _a.last, rest = __rest(_a, ["active", "label", "testId", "isFocused", "Icon", "last"]);
    return (_jsxs(React.Fragment, { children: [_jsx(IconButton, __assign({ size: "small", sx: {
                    color: active && isFocused
                        ? function (theme) { return theme.palette.primary.main; }
                        : isFocused
                            ? COLORS.P_MED_EMPHASIS
                            : COLORS.P_DISABLED,
                }, "data-testid": "".concat(testId).concat(active ? "-active" : "") }, rest, { children: Icon ? _jsx(Icon, {}) : _jsx("b", { children: label }) })), !last && (_jsx(Box, { sx: {
                    bgcolor: isFocused ? COLORS.P_MED_EMPHASIS : COLORS.P_DISABLED,
                    height: "19px",
                    width: "1px",
                    mx: 1,
                } }))] }));
};
export default StyleControlButton;
